import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/christiecookies/frontend/frontastic/renderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/christiecookies/frontend/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/christiecookies/frontend/styles/slug.module.css");
